<template>
  <div
    id="Booking"
    @click="hideEle">
    <div class="header pr">
      <div class="new_booking">
        <div class="currentTime">
          {{currentTime}}
        </div>
        <div
          class="uploadBtn"
          type="text">
          <Output :ProgramItem="ProgramItem" from="pushStatus"/>
          <!-- 感叹号 -->
          <epg-interval-hint :ShowIntervalHint="ShowIntervalHint"></epg-interval-hint>
          <!-- epg -->
          <div class="download" @click="ExportEPG">
            <i class="iconfont icon-export"></i>&nbsp;&nbsp;{{ $t('lang.exportEPG') }}
          </div>
          <!-- Breaking Source EPG -->
          <breaking-source-epg></breaking-source-epg>
          <el-select v-model="eventModeType" @change="changeEventModes" >
            <el-option
              v-for="item in eventModesList"
              :key="item.type"
              :label="$t('lang.'+item.name)"
              :value="item.type"
              >
            </el-option>
          </el-select>
          <!-- <div class="eventModes-calendar">
            <i class="iconfont icon-calendar" @click="changeEventModes('calendar')"></i>
          </div>
          <div class="eventModes-list">
            <i class="iconfont icon-list" @click="changeEventModes('list')"></i>
          </div> -->
        </div>

      </div>
    </div>
    <div class="content">
      <calendar
        :calendar="isShow.calendar"
      ></calendar>
    </div>
  </div>
</template>
<script>
import calendar from './calendarModule'
import Outil from '../../assets/js/utils.js'
import { mapState } from 'vuex'
import Bus from '@/assets/js/vueBus.js'
import { playoutAnalyze } from '@/assets/js/googleAnalyze/playout.js'
import toTips from '@/assets/js/toTipsObj'
import EpgIntervalHint from '@/components/common/EpgIntervalHint.vue'
import BreakingSourceEpg from './common/BreakingSourceEpg.vue'
import Output from '@/views/Workbench/Output.vue'

const googleKey = 'playout'
export default {
  data () {
    return {
      // 显示间隙提示
      ShowIntervalHint: 0,
      downloadUrl: '',
      // 当前时间加时区
      currentTime: '',
      currentTimeTimer: null,
      // 左边上显示的url
      RsspUrl: '',
      copyFlag: false,
      event: {}, // 创建/编辑框内的数据
      isShow: {
        sourceList: false,
        RList: false,
        preview: false,
        showOtherRunn: false
      },
      clickIndex: 0,
      websockDate: [],
      eventModesList: [{ name: 'playoutDisplayMode', type: 'calendar' }, { name: 'eventDisplayMode', type: 'list' }],
      eventModeType: 'calendar',
      ProgramItem: null
    }
  },
  components: {
    calendar,
    EpgIntervalHint,
    BreakingSourceEpg,
    Output
  },
  created () {
    const channelInitConfig = localStorage.getItem('channelInitConfig') && JSON.parse(localStorage.getItem('channelInitConfig'))
    const programTabPrefix = channelInitConfig && channelInitConfig.urlInfo.programTabPrefix
    this.ProgramItem = Outil.getProgramReceiver()
    this.Jurisdiction(programTabPrefix.playoutTabPrefix)
    // this.getCurrentTime()
    this.$store.commit('playout/CloneDisabled')
    // this.getEPGUrl(0)
  },
  mounted () {
  },
  computed: mapState({
    State: (state) => state,
    pageRequest: (state) => state.websocket.pageRequest,
    pageRWebsocket: (state) => state.websocket.pageRWebsocket,
    pageSerBusRequest: (state) => state.websocket.pageSerBusRequest,
    // 行为同步websocket
    BehaviorWebsocket: (state) => state.websocket.BehaviorWebsocket,
    // 用户权限
    UserChannelPermission: (state) => state.playout.UserChannelPermission
  }),
  methods: {
    // 获取当前时间
    getCurrentTime () {
      this.currentTime = `${this.transitionHourly(new Date())} ${Intl.DateTimeFormat().resolvedOptions().timeZone}`
      this.currentTimeTimer = setInterval(() => {
        const time = this.transitionHourly(new Date())
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        this.currentTime = `${time} ${timeZone}`
      }, 1000)
    },
    // 导出24的event
    ExportEPG () {
      this.axios({
        method: 'post',
        url: Outil.getUrl('/EPG/url'),
        data: {
          programId: this.$BehaviorSyns.getProgramId()
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            this.downloadUrl = res.data.result
            const objectUrl = `${res.data.result}?type=${Outil.return32Str()}`
            const download = document.createElement('a')
            download.href = objectUrl
            download.click()
            download.remove()
          }
        } else {
          if (res.data.errorCode == '80602024') {
            this.ShowIntervalHint++
          }
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 获取EPG的url
    getEPGUrl (type) {
      this.axios({
        method: 'post',
        url: Outil.getUrl('/EPG/copyUrl'),
        data: {
          programId: this.$BehaviorSyns.getProgramId()
        },
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            this.downloadUrl = res.data.result
          }
        } else if (type) {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // 24小时制转12小时制
    transitionHourly (time) {
      if (time) {
        let type = ''
        let hour = time.getHours()
        let min = time.getMinutes()
        let s = time.getSeconds()
        const TimeFormat = Outil.getDateTimeFormat()
        if (TimeFormat.broadcastTimeFormat) {
          hour = hour >= 0 && hour < 10 ? `0${hour}` : hour
        } else if (hour >= 0 && hour <= 11) {
          type = 'AM'
          hour = hour == 0 ? 12 : hour
        } else {
          type = 'PM'
          hour = hour == 12 ? hour : hour - 12
        }
        min = min >= 0 && min < 10 ? `0${min}` : min
        s = s >= 0 && s < 10 ? `0${s}` : s
        return `${hour}:${min}:${s} ${type}`
      }
    },
    // 判断权限
    Jurisdiction (tabPrefix) {
      const ProgramRMessage = Outil.getProgramReceiver().ProgramId
      this.axios.post(Outil.getUrl('/programTeamMember/openPlayout'), {
        programId: ProgramRMessage,
        tabPrefix
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          // 建立行为同步的websocket
          if (this.BehaviorWebsocket) {
            this.$BehaviorSyns.BehaviorWebsocket('off')
            this.$BehaviorSyns.BehaviorWebsocket('init', tabPrefix)
          } else {
            this.$BehaviorSyns.BehaviorWebsocket('init', tabPrefix)
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
          if (this.UserChannelPermission == 5) {
            this.$router.push({
              path: 'wb'
            })
          } else {
            this.$router.push({
              path: 'po'
            })
          }
        }
      }).catch(() => {})
    },
    // 获取r边上的那个url
    getRsspUrl () {
      const selectR = Outil.getProgramReceiver()
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/extra/getIsspUrl', {
        receiverId: selectR.peerId
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.RsspUrl = res.data.result
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
          this.RsspUrl = ''
        }
      }).catch(() => {})
    },
    // tableview中切换tab
    switchTab (val) {
      this.copyFlag = val
    },
    // 切换event展示模式
    changeEventModes () {
      const calendar_box = document.getElementsByClassName('calendar_box')[0]
      if (calendar_box && calendar_box.style && calendar_box.style.display == 'none') {
        this.$message.info(this.$t('lang.CalendarModeLimit'))
        if (this.eventModeType == 'calendar') {
          this.eventModeType = 'list'
        } else {
          this.eventModeType = 'calendar'
        }
        return
      }
      Bus.$emit('changeEventModes', this.eventModeType)
    },
    // 隐藏元素
    hideEle () {
      this.clickIndex++
      for (var key in this.isShow.calendar) {
        this.isShow.calendar[key] = false
      }
    }
  },
  beforeDestroy () {
    if (this.$createWebsocket.pageRequest && this.pageRequest) {
      this.$createWebsocket.pageRequest('stop', 'listEventRunning') // 停止websocket
    }
    if (this.currentTimeTimer) clearInterval(this.currentTimeTimer)
  }
}
</script>
<style lang="less" scoped>
#Booking {
  height: 100%;
  background: #444;
  input,
  textarea {
    outline: none;
  }
  p {
    margin-bottom: 0;
  }
  .header {
    height: 60px;
    background: #252525;
    // z-index: 1998;
    .table_view {
      height: 100%;
      text-align: left;
      margin-left: 34px;
      // width: 274px;
      // width: 360px;
      width: 490px;
      font-size: 24px;
      p {
        height: 100%;
        padding-top: 18px;
        text-align: center;
        width: 100px;
      }
      p {
        margin-right: 30px;
      }
      p:last-child {
        margin-right: 0;
      }
      p.active {
        border-bottom: 4px solid #33ab4f;
        color: #fff;
      }
      .scte_box {
        padding-top: 13px;
      }
      .scte {
        display: inline-block;
        border: 1px solid #ccc;
        font-size: 12px;
        width: 38px;
        height: 23px;
        line-height: 23px;
        padding: 0;
        border-radius: 5px;
      }
    }
    .booking_execute {
      font-size: 10px;
      line-height: 60px;
      padding-left: 15px;
      z-index: 3036;
      .circle {
        width: 10px;
        height: 10px;
        border-radius: 5px;
        background-color: #33ab4f;
        left: 0;
      }
      .booking_exe_info {
        z-index: 3036;
        width: 400px;
        text-align: left;
        .more {
          position: absolute;
          right: 0;
          top: 55%;
          transform: translateY(-50%);
          border-width: 8px;
        }
      }
      button:hover {
        background-color: rgba(216, 216, 216, 0.2);
      }
      button {
        width: 100px;
        height: 26px;
        background: rgba(216, 216, 216, 0);
        line-height: 26px;
        border-radius: 4px;
        border: 1px solid #757575;
        text-align: center;
        margin-top: 17px;
        margin-left: 20px;
        cursor: pointer;
      }
      .runnings_info {
        width: 100%;
        position: absolute;
        left: -6px;
        top: 40px;
        background: #666;
        border-radius: 4px;
        z-index: 100;
        li {
          height: 25px;
          line-height: 25px;
          padding-left: 10px;
          padding-right: 5px;
          cursor: pointer;
        }
        li:hover {
          background: rgba(0, 208, 105, 0.2);
        }
      }
    }
    .new_booking {
      height: 100%;
      margin-right: 40px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      .CopyLink {
        display: flex;
        margin-left: 30px;
        .UrlTitle {
          width: 170px;
          margin: 0 10px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }
      .currentTime{
        width: 330px;
        height: 22px;
        font-size: 18px;
        color: #EC5050;
        line-height: 22px;
        text-align: right;
      }
      .uploadBtn {
        width: 45%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        .download{
          width: 149px;
          height: 26px;
          line-height: 26px;
          border-radius: 2px;
          border: 1px solid #666666;
          font-size: 14px;
          color: #dfdfdf;
          cursor: pointer;
        }
        .copyUrl{
          width: 26px;
          height: 26px;
          border-radius: 2px;
          border: 1px solid #666666;
          margin-left: 5px;
          cursor: pointer;
          i{
            font-size: 14px;
          }
        }
      ::v-deep  .el-select{
        padding-left: 20px;
          input{
            border: none;
            background:#252525 ;
          }
          .el-input__suffix{
            right: 20px;
          }
        }
      }
    }
  }
  .content {
    background: #444;
    height: calc(100% - 60px);
  }
  .create {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #666;
    opacity: 0.65;
    z-index: 100;
  }
}
::v-deep .el-popper[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: #fff;
}
::v-deep .table_view .filter .el-input__inner {
  cursor: pointer;
}
::v-deep .el-input.el-input--small .el-input__inner {
  background: #fff;
  border-color: #e4e4e4;
}
::v-deep .el-date-picker__editor-wrap .el-input.el-input--small .el-input__inner {
  color: #000;
}
::v-deep .el-message {
  z-index: 30000 !important;
}
// ::v-deep .el-dialog__wrapper {
//     z-index: 2038!important;
// }
@media (min-width: 500px) and (max-width: 759px) {
  #Booking {
    .content {
      clear: both;
    }
    .header {
      .new_booking {
        margin-right: 10px;
        padding-top: 16px;
        margin-top: 0px;
      }
      .table_view {
        margin-left: 10px;
        width: 189px;
        p {
          width: 65px;
          &:first-child {
            margin-right: 5px;
          }
        }
      }
    }
  }
}
@media (max-width: 1024px) {
  #Booking .header .table_view {
    margin-left: -5px;
  }
}
</style>

<style lang="less">
.el-picker-panel.el-date-picker.el-popper.pick_date_time {
  z-index: 2039 !important;
}
</style>
